class StepTabs extends HTMLElement {
	connectedCallback() {
		this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
		this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
		this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab)));
	}
	activate(tab) {
		const id = tab.getAttribute('aria-controls');
		this.tabs.forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
		this.panels.forEach((p) => {
			if (p.id === id) p.removeAttribute('hidden');
			else p.setAttribute('hidden', '');
		});
	}
}
customElements.define('step-tabs', StepTabs);
